import { render, staticRenderFns } from "./RecordSearchTab.vue?vue&type=template&id=7dff81ef&scoped=true&"
import script from "./RecordSearchTab.vue?vue&type=script&lang=js&"
export * from "./RecordSearchTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dff81ef",
  null
  
)

export default component.exports